import * as React from 'react'

function SvgIconMathSubstraction(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 32 32" width="1em" height="1em" {...props}>
      <g
        id="math-substraction"
        aria-labelledby="t-math-substraction d-math-substraction"
      >
        <title id="t-math-substraction">{'Substraction'}</title>
        <desc id="d-math-substraction">{'Math symbol for substraction'}</desc>
        <path d="M31 17H1a1 1 0 110-2h30a1 1 0 110 2z" />
      </g>
    </svg>
  )
}

export default SvgIconMathSubstraction
